import { render, staticRenderFns } from "./addStoryInJourney.vue?vue&type=template&id=8f5c5646&scoped=true&"
import script from "./addStoryInJourney.vue?vue&type=script&lang=js&"
export * from "./addStoryInJourney.vue?vue&type=script&lang=js&"
import style0 from "./addStoryInJourney.vue?vue&type=style&index=0&id=8f5c5646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c5646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VRow})
